import ShelfProductsDetail from 'src/modules/ShelfProductsDetail'
import withModal from 'src/hoc/withModal'

export default withModal(ShelfProductsDetail)
